var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSteps = function SvgSteps(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 142,
    viewBox: "0 0 161 142",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3496 118.02L68.6896 125.72L160.39 87.21L142.05 79.5L50.3496 118.02Z",
    fill: "#F4AB9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3496 118.02V133.43L68.6896 141.13V125.72L50.3496 118.02Z",
    fill: "#1EC2CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6904 125.72L160.39 87.21V102.61L68.6904 141.13V125.72Z",
    fill: "#024B85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.400391 78.2502L18.7404 85.9602L110.45 47.4402L92.1104 39.7402L0.400391 78.2502Z",
    fill: "#F4AB9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.400391 78.25V93.66L18.7404 101.36V85.96L0.400391 78.25Z",
    fill: "#1EC2CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7402 85.9599L110.45 47.4399V62.8499L18.7402 101.36V85.9599Z",
    fill: "#024B85"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7298 12.2202C66.7298 22.2202 58.6298 33.6702 48.6398 37.8102C42.7398 40.2502 37.4998 39.6002 34.1998 36.6002C31.9098 34.5102 30.5498 31.3002 30.5498 27.2102C30.5498 17.2102 38.6498 5.76022 48.6398 1.62022C58.6298 -2.51978 66.7298 2.23022 66.7298 12.2202Z",
    fill: "#FFB45D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4205 50.7502C39.7973 48.3833 38.9881 46.0695 38.0005 43.8302C38.0005 43.8302 37.3405 42.3502 34.2305 36.6002L63.2305 24.4102C61.7105 27.7902 60.1705 31.5202 58.7205 35.5502C57.6005 38.6802 56.6705 41.6102 55.8805 44.3402L40.4205 50.7502Z",
    fill: "#FFB45D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8999 49.1501L41.5999 54.6601C40.9399 54.9301 40.4199 54.6601 40.4199 53.9701V52.5601C40.4482 52.2013 40.5727 51.8568 40.7803 51.5629C40.988 51.2689 41.2712 51.0365 41.5999 50.8901L54.8999 45.3801C55.5499 45.1101 56.0799 45.3801 56.0799 46.0701V47.4801C56.0517 47.8388 55.9272 48.1833 55.7195 48.4773C55.5118 48.7712 55.2286 49.0036 54.8999 49.1501Z",
    fill: "#024B85"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6799 53.0001L41.8199 58.3301C41.0499 58.6501 40.4199 58.3301 40.4199 57.5001C40.4499 57.0711 40.596 56.6583 40.8426 56.306C41.0892 55.9537 41.4271 55.6751 41.8199 55.5001L54.6799 50.1701C55.4499 49.8501 56.0799 50.1701 56.0799 50.9901C56.0517 51.4209 55.9065 51.8358 55.6597 52.19C55.413 52.5443 55.0742 52.8244 54.6799 53.0001Z",
    fill: "#024B85"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6304 57.4001L43.8704 61.0001C43.2204 61.2701 42.6904 61.0001 42.6904 60.3101V59.8601C42.7187 59.5013 42.8432 59.1568 43.0509 58.8629C43.2586 58.5689 43.5417 58.3365 43.8704 58.1901L52.6304 54.5601C53.2804 54.2901 53.8104 54.5601 53.8104 55.2601V55.7001C53.7875 56.0641 53.6654 56.4149 53.4574 56.7145C53.2494 57.0142 52.9634 57.2512 52.6304 57.4001Z",
    fill: "#024B85"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1496 28.53L44.6496 29.15C44.381 29.3149 44.0801 29.4202 43.7673 29.4588C43.4544 29.4973 43.137 29.4682 42.8364 29.3734C42.5358 29.2785 42.2591 29.1202 42.025 28.9092C41.7909 28.6981 41.6049 28.4392 41.4796 28.15C41.1163 27.4355 40.992 26.6232 41.1253 25.8329C41.2585 25.0425 41.6421 24.3158 42.2196 23.76C42.4823 23.5279 42.7967 23.362 43.1365 23.2761C43.4764 23.1902 43.8318 23.1867 44.1732 23.2659C44.5147 23.3452 44.8323 23.5049 45.0995 23.7317C45.3668 23.9585 45.5759 24.2459 45.7096 24.57C45.8388 24.8213 45.9395 25.0862 46.0096 25.36V25.36L46.0696 26.83L46.1496 28.53Z",
    stroke: "#024B85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0504 48.0298L46.1504 28.5298",
    stroke: "#024B85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5804 27.5298L46.1504 28.5298",
    stroke: "#024B85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3496 26.7901L51.8496 26.1701C52.9696 25.9301 54.3196 24.3801 55.0196 22.5001C55.7696 20.4401 55.4396 18.7501 54.2796 18.7201C53.1196 18.6901 51.5496 20.3601 50.7896 22.4201C50.6677 22.7465 50.5675 23.0806 50.4896 23.4201V23.4201L50.4296 25.0001L50.3496 26.7901Z",
    stroke: "#024B85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3502 26.79L49.4502 47.04",
    stroke: "#024B85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3499 26.79L47.9199 27.79",
    stroke: "#024B85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSteps, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/steps.3c7d7ab0.svg";
export { ForwardRef as ReactComponent };